import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PostOrganisationLogoRequestType,
  PostOrganisationLogoResponseType,
} from '../types';

export const postOrganisationLogo = async ({
  pathParams: { organisationId },
  bodyParams: { logo },
}: PostOrganisationLogoRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/logo`;

  const formData = new FormData();
  formData.append('logo', logo);

  const response = await apiAuthClient.post<PostOrganisationLogoResponseType>(
    url,
    formData,
  );

  return response.data.data;
};
